<template lang="pug">
  #properties.center-panel.md-scrollbar.md-theme-default
    md-content.full-height.md-layout-row.md-gutter.md-elevation-1(md-theme="white")
      module-menu
      .md-flex(md-theme="white")
        md-table(md-theme="white" v-if="!Object.keys(properties).length")
          md-table-row
            md-table-cell.load В модуле не создано ни одного свойства

        form.md-scrollbar.md-theme-default(md-theme="white" v-if="Object.keys(properties).length")
          md-card-content
            module-property(v-for="property in properties" v-bind:key="property.id" v-bind:property="property")
</template>

<script>
  import ModuleMenu from './menu.vue';
  import ModuleProperty from '../../../components/ModulePtoperty';

  export default {
    data() {
      return {
      }
    },
    watch: {
      '$route.params.code'() {
        this.getModuleProperties();
      }
    },
    components: {
      ModuleMenu,
      ModuleProperty
    },
    computed: {
      properties() {
        return this.$store.state.module.properties;
      }
    },
    created() {
      this.getModuleProperties();
    },
    methods: {
      getModuleProperties() {
        this.$store.dispatch('module/getModuleProperties');
      }
    }
  }
</script>
<style scoped lang="sass">
  .property-row.hovered
    .md-table-cell
      background-color: var(--md-theme-default-highlight-on-background, rgba(0, 0, 0, 0.08));
</style>



// WEBPACK FOOTER //
// Properties.vue?3e53e384